import { create } from 'zustand';
import { ONBOARDINGSTAGE, defaultShareHolder } from '../../data/onboardingData';
import { persist, createJSONStorage } from 'zustand/middleware';
import { isValidEmail } from '../../utilities/general';

const benueLGAs = [
  { id: 1000, stateId: 24, value: 'Ado', label: 'Ado' },
  { id: 1001, stateId: 24, value: 'Agatu', label: 'Agatu' },
  { id: 1002, stateId: 24, value: 'Apa', label: 'Apa' },
  { id: 1003, stateId: 24, value: 'Buruku', label: 'Buruku' },
  { id: 1004, stateId: 24, value: 'Gboko', label: 'Gboko' },
  { id: 1005, stateId: 24, value: 'Guma', label: 'Guma' },
  { id: 1006, stateId: 24, value: 'Gwer East', label: 'Gwer East' },
  { id: 1007, stateId: 24, value: 'Gwer West', label: 'Gwer West' },
  { id: 1008, stateId: 24, value: 'Katsina-Ala', label: 'Katsina-Ala' },
  { id: 1009, stateId: 24, value: 'Konshisha', label: 'Konshisha' },
  { id: 1010, stateId: 24, value: 'Kwande', label: 'Kwande' },
  { id: 1011, stateId: 24, value: 'Logo', label: 'Logo' },
  { id: 1012, stateId: 24, value: 'Makurdi', label: 'Makurdi' },
  { id: 1013, stateId: 24, value: 'Obi', label: 'Obi' },
  { id: 1014, stateId: 24, value: 'Ogbadibo', label: 'Ogbadibo' },
  { id: 1015, stateId: 24, value: 'Ohimini', label: 'Ohimini' },
  { id: 1016, stateId: 24, value: 'Oju', label: 'Oju' },
  { id: 1017, stateId: 24, value: 'Okpokwu', label: 'Okpokwu' },
  { id: 1018, stateId: 24, value: 'Otukpo', label: 'Otukpo' },
  { id: 1019, stateId: 24, value: 'Tarka', label: 'Tarka' },
  { id: 1020, stateId: 24, value: 'Ukum', label: 'Ukum' },
  { id: 1021, stateId: 24, value: 'Ushongo', label: 'Ushongo' },
  { id: 1022, stateId: 24, value: 'Vandeikya', label: 'Vandeikya' }
];

const initialState = {
  step: ONBOARDINGSTAGE.BUSINESS_DETAILS,
  email: '',
  phoneNumber: '',
  businessName: '',
  businessId: '',
  locations: [],
  states: [],
  cities: [],
  lgas: [],
  lcdas: [],
  countries: [],
  shareholders: [defaultShareHolder],
  shareholdersErrors: [null],
  merchantDetails: {},
  businessDetails: {},
  userNINDetails: {},
  UserBVNDetails: {},
  merchantFullName: '',
  referralCode: '',
  bankAccountNumber: null,
  tierOneData: {},
  permissions: [],
  permissionsLoaded: false
};

const useOnboardingStore = create(
  persist(
    (set, get) => ({
      ...initialState,
      resetOnboardingState: () => {
        set((state) => {
          return {
            ...state,
            ...initialState
          };
        });
      },
      setLocations: (location) => {
        set((state) => {
          return {
            ...state,
            locations: location
          };
        });
      },
      setStates: (location) => {
        set((state) => {
          return {
            ...state,
            states: location
          };
        });
      },
      setCountries: (location) => {
        set((state) => {
          return {
            ...state,
            countries: location
          };
        });
      },
      setCity: (location) => {
        set((state) => {
          return {
            ...state,
            cities: location
          };
        });
      },
      setLgas: (location) => {
        set((state) => {
          // hot fix for benue state lga not being returned from the backend
          return {
            ...state,
            lgas: [...benueLGAs, ...location]
          };
        });
      },
      setLcdas: (location) => {
        set((state) => {
          return {
            ...state,
            lcdas: location
          };
        });
      },
      setEmail: (email) => {
        set((state) => {
          return {
            ...state,
            email: email
          };
        });
      },
      setPhoneNumber: (phoneNumber) => {
        set((state) => {
          return {
            ...state,
            phoneNumber
          };
        });
      },
      setBusinessName: (businessName) => {
        set((state) => {
          return {
            ...state,
            businessName: businessName
          };
        });
      },
      setBusinessId: (businessId) => {
        set((state) => {
          return {
            ...state,
            businessId: businessId
          };
        });
      },
      setStep: (step) => {
        set((state) => {
          return {
            ...state,
            step: step
          };
        });
      },
      resetShareholders: () => {
        set((state) => {
          return {
            ...state,
            shareholders: [defaultShareHolder]
          };
        });
      },
      addShareholder: () => {
        set((state) => {
          const newShareholders = [...state.shareholders, defaultShareHolder];
          return {
            ...state,
            shareholders: newShareholders,
            shareholdersErrors: state.shareholdersErrors
          };
        });
      },
      deleteShareholder: (sIndex) => {
        set((state) => {
          const newShareholders = state.shareholders.filter(
            (item, index) => index !== sIndex
          );
          return {
            ...state,
            shareholders: newShareholders,
            shareholdersErrors: state.shareholdersErrors
          };
        });
      },
      updateShareholder: (shareHolderIndex, updatedData) => {
        set((state) => {
          const newShareholders = state.shareholders.map(
            (shareholder, index) =>
              index === shareHolderIndex
                ? { ...shareholder, ...updatedData }
                : shareholder
          );
          return {
            ...state,
            shareholders: newShareholders,
            shareholdersErrors: state.shareholdersErrors
          };
        });
      },
      validateShareholders: () => {
        const state = get();
        const errors = state.shareholders.map((shareholder) => {
          const errorObject = {};
          if (!shareholder.sharesowned) {
            errorObject.sharesowned = 'Shares information is required';
          } else if (parseInt(shareholder.sharesowned) < 5) {
            errorObject.sharesowned = 'Shares must be greater than 5%';
          }
          if (!shareholder.shareholderbvn) {
            errorObject.shareholderbvn = 'BVN is required';
          } else if (shareholder.shareholderbvn.length !== 11) {
            errorObject.shareholderbvn = 'BVN must be 11 digits';
          } else if (!shareholder.isBvnValidated) {
            errorObject.shareholderbvn =
              'Invalid BVN. Please validate the BVN.';
          }

          if (!shareholder.idType) {
            errorObject.idType = 'ID type is required';
          }
          return Object.keys(errorObject).length > 0 ? errorObject : null;
        });
        set({ shareholdersErrors: errors });
        return errors;
      },

      setUserBVNDetails: (payload) => {
        set((state) => ({
          ...state,
          UserBVNDetails: payload
        }));
      },
      setBusinessVerificationStatus: (status) => {
        set((state) => ({
          ...state,
          businessVerificationStatus: status
        }));
      },

      validateShareholders: () => {
        const state = get();
        const errors = state.shareholders.map((shareholder) => {
          const errorObject = {};
          if (!shareholder.sharesowned) {
            errorObject.sharesowned = 'Shares information is required';
          } else if (parseInt(shareholder.sharesowned) < 5) {
            errorObject.sharesowned = 'Shares must be greater than 5%';
          }
          if (!shareholder.shareholderbvn) {
            errorObject.shareholderbvn = 'BVN is required';
          } else if (shareholder.shareholderbvn.length !== 11) {
            errorObject.shareholderbvn = 'BVN must be 11 digits';
          } else if (!shareholder.isBvnValidated) {
            errorObject.shareholderbvn =
              'Invalid BVN. Please validate the BVN.';
          }

          if (!shareholder.idType) {
            errorObject.idType = 'ID type is required';
          }
          return Object.keys(errorObject).length > 0 ? errorObject : null;
        });
        set({ shareholdersErrors: errors });
        return errors;
      },
      setMerchantDetails: (payload) => {
        set((state) => ({
          ...state,
          merchantDetails: payload
        }));
      },
      setBusinessDetails: (payload) => {
        set((state) => ({
          ...state,
          businessDetails: payload
        }));
      },
      setUserNINDetails: (payload) => {
        set((state) => ({
          ...state,
          userNINDetails: payload
        }));
      },
      setUserBVNDetails: (payload) => {
        set((state) => ({
          ...state,
          UserBVNDetails: payload
        }));
      },
      setMerchantFullName: (payload) => {
        set((state) => ({
          ...state,
          merchantFullName: payload
        }));
      },
      setPermissions: (permissions) =>
        set({ permissions, permissionsLoaded: true }),
      setReferralCode: (code) => {
        // Action to set referralCode
        set((state) => ({
          ...state,
          referralCode: code
        }));
      },
      setBankAccountNumber: (bankAccountNumber) => set({ bankAccountNumber }),
      setBankName: (bankName) => set({ bankName }),
      setTierOneData: (tierOneData) =>
        set((state) => ({
          ...state,
          tierOneData
        }))
    }),

    {
      name: 'onboarding-storage',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export default useOnboardingStore;
